import dynamic from 'next/dynamic'

const Products = dynamic(() => import('./Products'), { ssr: false })
const AnnouncementBanner = dynamic(() => import('./AnnouncementBanner'), {
  ssr: true,
})
const InstagramFeed = dynamic(() => import('./InstagramFeed'), {
  ssr: false,
})
const SlideshowBanner = dynamic(() => import('./SlideshowBanner'), {
  ssr: true,
})
const ImageWithText = dynamic(() => import('./ImageWithText'), {
  ssr: true,
})
const CustomHtml = dynamic(() => import('./CustomHtml'), {
  ssr: false,
})
const PromotionFilmstrip = dynamic(() => import('./PromotionFilmstrip'), {
  ssr: false,
})
const WideBanner = dynamic(() => import('./WideBanner/WideBanner'), {
  ssr: false,
})
const MarketingPopup = dynamic(() => import('./MarketingPopup'), {
  ssr: false,
})
const Reservations = dynamic(() => import('./Reservations'), {
  ssr: false,
})

const sections = {
  products: Products,
  'announcement-banner': AnnouncementBanner,
  'instagram-feed': InstagramFeed,
  'slideshow-banner': SlideshowBanner,
  'image-with-text': ImageWithText,
  'custom-html': CustomHtml,
  'promotion-filmstrip': PromotionFilmstrip,
  'wide-banner': WideBanner,
  'marketing-popup': MarketingPopup,
  reservationsPage: Reservations,
  removableReservation: Reservations,
}

export default sections
